// Configuración de URLs para la aplicación
const config = {
  // En desarrollo usa localhost, en producción usa la URL del servidor
  API_BASE_URL: process.env.NODE_ENV === 'production' 
    ? '/api'  // Usar proxy interno
    : 'http://localhost:3002/api'
};

export default config;